import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import palette from '../styles/palette';

const Footer = () => {
  const styles = {
    footer: {
      px: '2%',
      width: '96%',
      my: { xs: '2vh' },
    },
    link: {
      color: palette.gt_teal_6,
      textDecoration: 'none',
    },
    terms: {
      display: 'flex',
      justifyContent: { xs: 'center', sm: 'flex-start' },
      alignItems: 'center',
    },
    rights: {
      display: 'flex',
      justifyContent: { xs: 'center', sm: 'flex-end' },
      alignItems: 'center',
    },
    divider: {
      color: palette.dark_gray,
    },
  };

  return (
    <footer className="App-footer" data-testid="footer-test">
      <Box sx={styles.footer}>
        <Grid
          container
          rowSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
          columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
          direction="row"
        >
          <Grid item xs={12} sm={6.5} md={6} lg={6}>
            <Box sx={styles.rights}>
              <Typography>
                GroundTruth © {new Date().getFullYear()}. All rights reserved.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={5.5} md={6} lg={6}>
            <Stack direction="row" spacing={1} sx={styles.terms}>
              <Grid item>
                <Typography>
                  <Link
                    target="_blank"
                    href="https://www.groundtruth.com/privacy-rights/"
                    sx={styles.link}
                  >
                    Terms
                  </Link>
                </Typography>
              </Grid>
              <Grid item>
                <Typography sx={styles.divider}>|</Typography>
              </Grid>
              <Grid item>
                <Typography>
                  <Link
                    target="_blank"
                    href="https://www.groundtruth.com/privacy-policy/"
                    sx={styles.link}
                  >
                    Privacy Policy
                  </Link>
                </Typography>
              </Grid>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </footer>
  );
};

export default Footer;
